import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, } from "@mui/material";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getMetodosDosimetria, getTiposDosimetria, } from "../../../../../../../../../../redux/actions/resolucion";
import FormikActions from "../../../../../../../../../commons/formik/FormikActions";
import FormikAutocomplete from "../../../../../../../../../commons/formik/FormikAutocomplete";
import FormikTextField from "../../../../../../../../../commons/formik/FormikTextField";
import CircularLoading from "../../../../../../../../../commons/loading/CircularLoading";
import { StyledResolucion } from "../../../../../../../../../styled/Prevencion";
import { validateDosimetriaForm } from "../../../../../formValidations";

const DosimetriaForm = ({ open, handleClose, handleSubmit, initialValues, loading }) => {
    const dispatch = useDispatch();
    const tiposDosimetria = useSelector(
        (state) => state.resolucion.tiposDosimetria
    );
    const metodosDosimetria = useSelector(
        (state) => state.resolucion.metodosDosimetria
    );

    return (
        <Dialog open={open} fullWidth maxWidth="sm">
            <DialogTitle>Administrar Dosimetría</DialogTitle>
            <Formik
                initialValues={initialValues}
                onSubmit={(values) => handleSubmit(values)}
                validationSchema={validateDosimetriaForm}
            >
                {() => (
                    <>
                        {
                            loading ? <CircularLoading /> :
                                (
                                    <Form>
                                        <DialogContent>
                                            <Grid container >
                                                {/* Tipo de Dosimetría */}
                                                <StyledResolucion.DialogGridItem item xs={12}>
                                                    <FormikAutocomplete
                                                        name="tipoDosimetria"
                                                        label="Tipo de Dosimetría *"
                                                        options={tiposDosimetria.data}
                                                        renderOption={(option) => option.nombre}
                                                        fullWidth
                                                        getOptions={() => dispatch(getTiposDosimetria())}
                                                    />
                                                </StyledResolucion.DialogGridItem>

                                                {/* Métodos de Dosimetría */}
                                                <StyledResolucion.DialogGridItem item xs={12}>
                                                    <FormikAutocomplete
                                                        name="metodoDosimetria"
                                                        label="Métodos de Dosimetría *"
                                                        options={metodosDosimetria.data}
                                                        renderOption={(option) => option.nombre}
                                                        fullWidth
                                                        getOptions={() => dispatch(getMetodosDosimetria())}
                                                    />
                                                </StyledResolucion.DialogGridItem>

                                                {/* Cantidad de Personal */}
                                                <StyledResolucion.DialogGridItem item xs={12}>
                                                    <FormikTextField
                                                        name="cantidadPersonal"
                                                        label="Cantidad de Personal *"
                                                        fullWidth
                                                    />
                                                </StyledResolucion.DialogGridItem>

                                                {/* CUIT */}
                                                <StyledResolucion.DialogGridItem item xs={12}>
                                                    <FormikTextField name="cuitResponsable" label="CUIT *" fullWidth />
                                                </StyledResolucion.DialogGridItem>
                                            </Grid>
                                        </DialogContent>

                                        <DialogActions>
                                            <FormikActions handleCancel={handleClose} />
                                        </DialogActions>
                                    </Form>
                                )
                        }
                    </>
                )}
            </Formik>
        </Dialog>
    );
};

export default DosimetriaForm;
